import React from 'react';

import classNames from 'classnames';

import {Icon} from '../icon/icon';
import Spinner from '../spinner/spinner';

export interface IDataInfoProps {
    type: TDataInfoType;
    className?: string;
    text?: string;
    mentorAdvice?: IMentorAdviceProps;
}

export interface IMentorAdviceProps {
    greeting?: string;
    introductionText?: string;
    questions?: string[];
}

export type TDataInfoType = 'error' | 'loading' | 'info' | 'mentor';

const DataInfo = (props: IDataInfoProps): JSX.Element => {
    const className: string = classNames(
        'data-info',
        {
            [`data-info--type-${props.type}`]: props.type,
        },
        props.className,
    );

    const renderIcon = (): JSX.Element => {
        let iconName: string;

        if (props.type === 'error') {
            iconName = 'warning';
        } else if (props.type === 'mentor') {
            iconName = 'robot-happy';
        } else {
            iconName = 'info';
        }

        return (
            <Icon
                className="data-info__icon"
                name={iconName}
            />
        );
    };

    return (
        <div className={className}>
            {props.type === 'loading' ? <Spinner className="data-info__spinner" /> : renderIcon()}
            {props.text && <p>{props.text}</p>}
            {props.mentorAdvice && props.type === 'mentor' &&
                <div>
                    {props.mentorAdvice.greeting && <h4>{props.mentorAdvice.greeting}</h4>}
                    {props.mentorAdvice.introductionText && <p className={'data-info__mentor-intro'}>{props.mentorAdvice.introductionText}</p>}
                    {props.mentorAdvice.questions && props.mentorAdvice.questions.map((question, key) =>
                        <p key={key}><strong>{question}</strong></p>,
                    )}
                </div>}
        </div>
    );
};

export default DataInfo;
